const shuffleType = {
    station: "station",
    podcast: "podcast",
    nakiNigun: "naki-nigun-album",
};

export default shuffleType;
